import { SellerUpdateProfileForm } from "./SellerUpdateProfileForm";
import authUtil from '../../utils/auth_util';

import React from "react";
import Grid from '@mui/material/Grid';
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AuthHelper } from '../../utils/auth_helper';
import { useNavigate } from "react-router-dom";


function RedirectToHomeForm() {

  const { auth_user } = useSelector((state) => state.authUser)
  // const { auth_user } = authUtil.getCredentials('auth-token');
  console.log('---RedirectToHome--AppBar.js--auth_user:', auth_user)
  const navigate = useNavigate();
  let navigate_link = null;


  const handleRedirect = () => {
    let navigate_link = '/seller/request-otp-to-login'
    if (auth_user?.user_type == 'Employee') {
      navigate_link = '/emp/bid-listing'
    } else if (auth_user?.user_type == 'Seller') {
      navigate_link = '/seller/emp-bid-listing'
    }
    console.log('---auth_user:', auth_user)
    console.log('---handleRedirect:', navigate_link)
    navigate(navigate_link)
  }

  React.useEffect(() => {
    handleRedirect()
  }, navigate_link);

  return (
    <div>
    </div>
  );

}


export { RedirectToHomeForm };
